/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/home-improvements': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M9.062 8.002a8.005 8.005 0 006.778 6.915V17h.006v5.741c0 .518-.44.942-.979.942h-2.934c-.538 0-.979-.424-.979-.942v-4.708H7.041v4.708c0 .518-.44.942-.978.942H3.128c-.538 0-.978-.424-.978-.942V16.15H.487c-.45 0-.655-.537-.323-.82l8.178-7.09c.203-.175.464-.254.72-.238zM17 0a7 7 0 110 14 7 7 0 010-14zm-2.625 3.247l1.368 1.368a.375.375 0 010 .531l-.6.6a.369.369 0 01-.53 0l-1.369-1.368a2.45 2.45 0 00.471 2.8c.701.7 1.726.885 2.597.557l2.999 3a.985.985 0 001.398 0 .985.985 0 000-1.399l-2.984-2.988a2.452 2.452 0 00-.547-2.633 2.45 2.45 0 00-2.803-.468z" _fill="#000" fill-rule="evenodd"/>'
  }
})
